import { faUpload } from "@fortawesome/pro-regular-svg-icons/faUpload";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconUpload: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faUpload} />;
};
